import { observable, action, computed } from 'mobx';
import type { CXRootStore } from '../../stores/cx-root.store';
import { _get } from '../../../../utils/lodash.utils';
import {
    IInstantPayClient,
    IInstantPayVendor,
    IInstantPayProposal,
    IInstantPayInvoice,
    IInstantPayStyleContainer
} from '../../../../types/instant-pay.types';

export enum Routes {
    LoadError = 'LOAD_ERROR',
    ThankYou = 'THANK_YOU',
    CheckoutForm = 'CHECKOUT_FORM',
    Loading = 'LOADING'
}

export enum InvalidReasons {
    AlreadyPaid = 'already_paid',
    TokenExpired = 'token_expired'
}

export class InstantPayStore {
    rootStore: CXRootStore = null;
    @observable client: IInstantPayClient;
    @observable vendor: IInstantPayVendor;
    @observable proposal: IInstantPayProposal;
    @observable invoice: IInstantPayInvoice;
    @observable styleContainer: IInstantPayStyleContainer;
    @observable loadError: boolean = false;
    @observable activeRoute: Routes = Routes.Loading;
    @observable paymentError: any = null;
    @observable invalidReason: InvalidReasons = null;
    @observable createNewUrl: string = null;
    @observable stripeLoadCalled: boolean = false;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    @action
    updatePaymentData(response) {
        if (!response) {
            return;
        }
        this.vendor = response.vendor;
        // If we got here from pay returning an invalid_reason, this field won't exist
        // TODO: unify server response api to return same format response in all cases
        if (response.style_container) {
            this.styleContainer = response.style_container;
        }

        if (response.invalid_reason) {
            this.invalidReason = response.invalid_reason;
            this.createNewUrl = response.create_new_url;
            this.setActiveRoute(Routes.ThankYou);
        } else {
            this.client = response.client;
            this.proposal = response.proposal;
            this.setActiveRoute(Routes.CheckoutForm);
        }
    }

    @action.bound
    setActiveRoute(route: Routes) {
        this.activeRoute = route;
    }

    @action
    setStripeLoadCalled(called: boolean) {
        this.stripeLoadCalled = called;
    }

    @action
    setInvoice(invoice: IInstantPayInvoice) {
        this.invoice = invoice;
    }

    @action
    setPaymentError(error: any) {
        this.paymentError = error;
    }

    // TODO: this should be a function on a vendor model
    @computed
    get buttonStyle() {
        const { configuration } = this.rootStore.clientPortalConfigStore;
        if (!this.styleContainer && !configuration) {
            return null;
        }

        if (!_get(this.styleContainer, 'button_component_style')) {
            return {
                color: _get(configuration, 'brand.text_color'),
                background: _get(configuration, 'brand.brand_color')
            };
        }

        const { button_component_style: buttonStyle } = this.styleContainer;

        return {
            color: buttonStyle.font_color,
            background: buttonStyle.background_color,
            fontWeight: buttonStyle.font_weight
        };
    }
}
